import type { ReactElement } from 'react';

interface BitbucketIconProps {
  className?: string;
}

/**
 * Bitbucket logo from Simple Icons (CC0 / public domain).
 * https://simpleicons.org/?q=bitbucket
 */
export function BitbucketIcon({ className }: BitbucketIconProps): ReactElement {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path d="M.778 1.213a.768.768 0 00-.768.892l3.263 19.81c.084.5.515.868 1.022.873H19.95a.772.772 0 00.77-.646l3.27-20.03a.768.768 0 00-.768-.891zM14.52 15.53H9.522L8.17 8.466h7.561z" />
    </svg>
  );
}
